import { JSEncrypt } from 'jsencrypt';
import { parseBigInt } from 'jsencrypt/lib/lib/jsbn/jsbn';

/**
 * 依赖包：jsencrypt
 * 使用示例：
 * import { decrypt } from "@/utils/RSADecrypt";
 * // 公钥
 * const publicKey = `-----BEGIN PUBLIC KEY-----
 * MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDMpkV/EUX35Lp57YaAJ34DTc7nKfDjzCX/vjAdqI57CQadoMDBzn+BbKkLEbG45D52I1ko2gLMEA/rpY/qQw1+4mvivBAl68q3SUd/c9HnqhZjKGd/fcsLnebMDns0ZeG331q0rNEmwhZB4gGwjzNMLQ1nVt1YSQLosgV4t08P0wIDAQAB
 * -----END PUBLIC KEY-----`;
 * // 密文
 * const encryptedData =
 *   "eK66g+X2PJD/qXbEMQlH6NI/ikI4HsrXHa3We1CtTdmagTqe/8MnqGLJa1RDp9R5L+Bral4Z784e5k6eZmbqAAIhb2UsgYLK1OXWuRgNqV0jcyMK7Zw6Af0G8u5N2rVbNgWNsef0D+3d5SJ3FovPnfetK7C1pqHFPJaDexT/zmc=";
 * console.log("解密结果：", decrypt(encryptedData, publicKey));
 */
/**
 * RSA 加密 公钥
 */
const PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDMpkV/EUX35Lp57YaAJ34DTc7nKfDjzCX/vjAdqI57CQadoMDBzn+BbKkLEbG45D52I1ko2gLMEA/rpY/qQw1+4mvivBAl68q3SUd/c9HnqhZjKGd/fcsLnebMDns0ZeG331q0rNEmwhZB4gGwjzNMLQ1nVt1YSQLosgV4t08P0wIDAQAB
-----END PUBLIC KEY-----`;

/**
 * RSA 解密 密钥
 */
const PRIVATE_KEY = `-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDMpkV/EUX35Lp57YaAJ34DTc7nKfDjzCX/vjAdqI57CQadoMDBzn+BbKkLEbG45D52I1ko2gLMEA/rpY/qQw1+4mvivBAl68q3SUd/c9HnqhZjKGd/fcsLnebMDns0ZeG331q0rNEmwhZB4gGwjzNMLQ1nVt1YSQLosgV4t08P0wIDAQAB
-----END PUBLIC KEY-----`;

function pkcs1unpad2(d) {
  const b = d.toByteArray();
  let i = 0;
  while (i < b.length && b[i] === 0) {
    ++i;
  }
  ++i;
  while (b[i] !== 0) {
    if (++i >= b.length) {
      return null;
    }
  }
  let ret = '';
  while (++i < b.length) {
    const c = b[i] & 255;
    if (c < 128) {
      // utf-8 decode
      ret += String.fromCharCode(c);
    } else if (c > 191 && c < 224) {
      ret += String.fromCharCode(((c & 31) << 6) | (b[i + 1] & 63));
      ++i;
    } else {
      ret += String.fromCharCode(((c & 15) << 12) | ((b[i + 1] & 63) << 6) | (b[i + 2] & 63));
      i += 2;
    }
  }
  return ret;
}

/**
 * RSA 公钥解密
 * @param encryptedData 待解密数据
 * @param publicKey 公钥
 */
function decrypt(encryptedData, publicKey = PRIVATE_KEY) {
  const encrypt = new JSEncrypt();
  encrypt.setPublicKey(publicKey);
  const rsaKey = encrypt.getKey();
  rsaKey.decrypt = function(ctext) {
    const c = parseBigInt(ctext, 16);
    const m = this.doPublic(c);
    if (m == null) {
      return null;
    }
    return pkcs1unpad2(m);
  };
  return encrypt.decrypt(encryptedData);
}

export { decrypt };
